import React from 'react';
import PropTypes from 'prop-types';
import AdminDataTable from 'components/admin/AdminDataTable';
import ResultTableTab from 'components/admin/result/ResultTableTab';
import {
  resultColumns,
  resultAttemptsCount,
  emptyResultColumns,
} from 'config/admin/result';

const ResultDataTable = ({
  clubRole,
  dataTypeOptions = [],
  optionValues,
  handleOptionChange,
  results,
  eventType,
  showEmptyTable = false,
  emptyMessage = 'No results yet.',
  // A relay's own columns and grid (config/admin/result.js, relayRaceColumns);
  // every other event takes its columns from its results, as before.
  columns: columnsOverride = null,
  gridTemplateColumns: gridOverride = null,
}) => {
  // An event with no results yet. With showEmptyTable the round tabs and an
  // empty table are drawn, so the page looks as it will once results are
  // added; without it nothing is drawn, as before.
  if (!results.length) {
    if (!showEmptyTable) return null;
    const columns = columnsOverride || emptyResultColumns(eventType);
    const gridTemplateColumns =
      gridOverride ||
      (columns.length === 7
        ? '1fr 5fr 2fr 2fr 2fr 2fr 2fr'
        : '2fr 5fr 3fr 3fr 3fr 3fr 3fr 4fr 3fr');
    return (
      <>
        <ResultTableTab
          clubRole={clubRole}
          dataTypeOptions={dataTypeOptions}
          optionValues={optionValues}
          handleOptionChange={handleOptionChange}
        />
        <AdminDataTable
          borderType="full"
          isAddedFeatures={false}
          columns={columns}
          data={[]}
          searchInputPlaceholder=""
          headStyle={{ gridTemplateColumns, background: '#f1f1f2' }}
          rowStyle={{ gridTemplateColumns }}
        />
        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          {emptyMessage}
        </div>
      </>
    );
  }

  return results.length ? (
    <>
      <ResultTableTab
        clubRole={clubRole}
        dataTypeOptions={dataTypeOptions}
        optionValues={optionValues}
        handleOptionChange={handleOptionChange}
      />
      <AdminDataTable
        borderType="full"
        isAddedFeatures={false}
        columns={columnsOverride || resultColumns(results)}
        data={results}
        searchInputPlaceholder=""
        headStyle={{
          gridTemplateColumns:
            gridOverride ||
            (results[0]?.unit === 'm' || eventType === 'High Jump'
              ? `1fr 5fr 2fr 2fr 2fr 2fr 2fr ${2 * resultAttemptsCount(results)}fr`
              : '2fr 5fr 3fr 3fr 3fr 3fr 3fr 4fr 3fr'),
          background: '#f1f1f2',
        }}
        rowStyle={{
          gridTemplateColumns:
            gridOverride ||
            (results[0]?.unit === 'm' || eventType === 'High Jump'
              ? `1fr 5fr 2fr 2fr 2fr 2fr 2fr ${2 * resultAttemptsCount(results)}fr`
              : '2fr 5fr 3fr 3fr 3fr 3fr 3fr 4fr 3fr'),
        }}
      />
    </>
  ) : null;
};

ResultDataTable.propTypes = {
  clubRole: PropTypes.string,
  dataTypeOptions: PropTypes.arrayOf(PropTypes.object),
  optionValues: PropTypes.object,
  handleOptionChange: PropTypes.func,
  results: PropTypes.array.isRequired,
  eventType: PropTypes.string,
  showEmptyTable: PropTypes.bool,
  emptyMessage: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.object),
  gridTemplateColumns: PropTypes.string,
};

export default ResultDataTable;
